import { Typography } from 'antd';
import styled from '@emotion/styled';

export const TextCell = styled(Typography.Text)`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.005em;
  text-align: left;
  color: #232b3a;
`;
